import { Core4MetricAverage } from '../../../model/Entities';
import {
    lacrosseCore4Age1012,
    lacrosseCore4Age1314,
    lacrosseCore4Age1516,
    lacrosseCore4Age1718,
    lacrosseCore4AgeCollege,
    lacrosseCore4AgePro,
} from './PlayerCore4LacrosseAges';
import {
    lacrosseCore4Metric10YD,
    lacrosseCore4Metric5105,
    lacrosseCore4MetricHandGripLT,
    lacrosseCore4MetricHandGripRT,
    lacrosseCore4MetricVerticalJump,
} from './PlayerCore4LacrosseMetrics';

export const lacrosseCore4Averages: Core4MetricAverage[] = [
    // ACCURACY
    // { age: lacrosseCore4Age1012, metric: lacrosseCore4MetricShotVeloR, gender: 'Male', average: 0 },
    // { age: lacrosseCore4Age1012, metric: lacrosseCore4MetricShotVeloL, gender: 'Male', average: 0 },
    // { age: lacrosseCore4Age1012, metric: lacrosseCore4MetricWallBallTestR, gender: 'Male', average: 0 },
    // { age: lacrosseCore4Age1012, metric: lacrosseCore4MetricWallBallTestL, gender: 'Male', average: 0 },

    // { age: lacrosseCore4Age1314, metric: lacrosseCore4MetricShotVeloR, gender: 'Male', average: 0 },
    // { age: lacrosseCore4Age1314, metric: lacrosseCore4MetricShotVeloL, gender: 'Male', average: 0 },
    // { age: lacrosseCore4Age1314, metric: lacrosseCore4MetricWallBallTestR, gender: 'Male', average: 0 },
    // { age: lacrosseCore4Age1314, metric: lacrosseCore4MetricWallBallTestL, gender: 'Male', average: 0 },

    // { age: lacrosseCore4Age1516, metric: lacrosseCore4MetricShotVeloR, gender: 'Male', average: 0 },
    // { age: lacrosseCore4Age1516, metric: lacrosseCore4MetricShotVeloL, gender: 'Male', average: 0 },
    // { age: lacrosseCore4Age1516, metric: lacrosseCore4MetricWallBallTestR, gender: 'Male', average: 0 },
    // { age: lacrosseCore4Age1516, metric: lacrosseCore4MetricWallBallTestL, gender: 'Male', average: 0 },

    // { age: lacrosseCore4Age1718, metric: lacrosseCore4MetricShotVeloR, gender: 'Male', average: 0 },
    // { age: lacrosseCore4Age1718, metric: lacrosseCore4MetricShotVeloL, gender: 'Male', average: 0 },
    // { age: lacrosseCore4Age1718, metric: lacrosseCore4MetricWallBallTestR, gender: 'Male', average: 0 },
    // { age: lacrosseCore4Age1718, metric: lacrosseCore4MetricWallBallTestL, gender: 'Male', average: 0 },

    // { age: lacrosseCore4AgeCollege, metric: lacrosseCore4MetricShotVeloR, gender: 'Male', average: 0 },
    // { age: lacrosseCore4AgeCollege, metric: lacrosseCore4MetricShotVeloL, gender: 'Male', average: 0 },
    // { age: lacrosseCore4AgeCollege, metric: lacrosseCore4MetricWallBallTestR, gender: 'Male', average: 0 },
    // { age: lacrosseCore4AgeCollege, metric: lacrosseCore4MetricWallBallTestL, gender: 'Male', average: 0 },

    // { age: lacrosseCore4AgePro, metric: lacrosseCore4MetricShotVeloR, gender: 'Male', average: 0 },
    // { age: lacrosseCore4AgePro, metric: lacrosseCore4MetricShotVeloL, gender: 'Male', average: 0 },
    // { age: lacrosseCore4AgePro, metric: lacrosseCore4MetricWallBallTestR, gender: 'Male', average: 0 },
    // { age: lacrosseCore4AgePro, metric: lacrosseCore4MetricWallBallTestL, gender: 'Male', average: 0 },

    // SPEED

    { age: lacrosseCore4Age1012, metric: lacrosseCore4Metric10YD, gender: 'Male', average: 2 },
    // { age: lacrosseCore4Age1012, metric: lacrosseCore4Metric40YD, gender: 'Male', average: 0 },

    { age: lacrosseCore4Age1314, metric: lacrosseCore4Metric10YD, gender: 'Male', average: 1.9 },
    // { age: lacrosseCore4Age1314, metric: lacrosseCore4Metric40YD, gender: 'Male', average: 0 },

    { age: lacrosseCore4Age1516, metric: lacrosseCore4Metric10YD, gender: 'Male', average: 1.8 },
    // { age: lacrosseCore4Age1516, metric: lacrosseCore4Metric40YD, gender: 'Male', average: 0 },

    { age: lacrosseCore4Age1718, metric: lacrosseCore4Metric10YD, gender: 'Male', average: 1.75 },
    // { age: lacrosseCore4Age1718, metric: lacrosseCore4Metric40YD, gender: 'Male', average: 0 },

    { age: lacrosseCore4AgeCollege, metric: lacrosseCore4Metric10YD, gender: 'Male', average: 1.7 },
    // { age: lacrosseCore4AgeCollege, metric: lacrosseCore4Metric40YD, gender: 'Male', average: 0 },

    { age: lacrosseCore4AgePro, metric: lacrosseCore4Metric10YD, gender: 'Male', average: 1.65 },
    // { age: lacrosseCore4AgePro, metric: lacrosseCore4Metric40YD, gender: 'Male', average: 0 },

    // AGILITY

    { age: lacrosseCore4Age1012, metric: lacrosseCore4Metric5105, gender: 'Male', average: 5.5 },

    { age: lacrosseCore4Age1314, metric: lacrosseCore4Metric5105, gender: 'Male', average: 5.2 },

    { age: lacrosseCore4Age1516, metric: lacrosseCore4Metric5105, gender: 'Male', average: 4.9 },

    { age: lacrosseCore4Age1718, metric: lacrosseCore4Metric5105, gender: 'Male', average: 4.7 },

    { age: lacrosseCore4AgeCollege, metric: lacrosseCore4Metric5105, gender: 'Male', average: 4.5 },

    { age: lacrosseCore4AgePro, metric: lacrosseCore4Metric5105, gender: 'Male', average: 4.4 },

    // STRENGTH

    { age: lacrosseCore4Age1012, metric: lacrosseCore4MetricVerticalJump, gender: 'Male', average: 16.5 },
    { age: lacrosseCore4Age1012, metric: lacrosseCore4MetricHandGripRT, gender: 'Male', average: 82.5 },
    { age: lacrosseCore4Age1012, metric: lacrosseCore4MetricHandGripLT, gender: 'Male', average: 82.5 },

    { age: lacrosseCore4Age1314, metric: lacrosseCore4MetricVerticalJump, gender: 'Male', average: 20 },
    { age: lacrosseCore4Age1314, metric: lacrosseCore4MetricHandGripRT, gender: 'Male', average: 100 },
    { age: lacrosseCore4Age1314, metric: lacrosseCore4MetricHandGripLT, gender: 'Male', average: 100 },

    { age: lacrosseCore4Age1516, metric: lacrosseCore4MetricVerticalJump, gender: 'Male', average: 24 },
    { age: lacrosseCore4Age1516, metric: lacrosseCore4MetricHandGripRT, gender: 'Male', average: 117.5 },
    { age: lacrosseCore4Age1516, metric: lacrosseCore4MetricHandGripLT, gender: 'Male', average: 117.5 },

    { age: lacrosseCore4Age1718, metric: lacrosseCore4MetricVerticalJump, gender: 'Male', average: 28 },
    { age: lacrosseCore4Age1718, metric: lacrosseCore4MetricHandGripRT, gender: 'Male', average: 132.5 },
    { age: lacrosseCore4Age1718, metric: lacrosseCore4MetricHandGripLT, gender: 'Male', average: 132.5 },

    { age: lacrosseCore4AgeCollege, metric: lacrosseCore4MetricVerticalJump, gender: 'Male', average: 32 },
    { age: lacrosseCore4AgeCollege, metric: lacrosseCore4MetricHandGripRT, gender: 'Male', average: 147.5 },
    { age: lacrosseCore4AgeCollege, metric: lacrosseCore4MetricHandGripLT, gender: 'Male', average: 147.5 },

    { age: lacrosseCore4AgePro, metric: lacrosseCore4MetricVerticalJump, gender: 'Male', average: 36 },
    { age: lacrosseCore4AgePro, metric: lacrosseCore4MetricHandGripRT, gender: 'Male', average: 162.5 },
    { age: lacrosseCore4AgePro, metric: lacrosseCore4MetricHandGripLT, gender: 'Male', average: 162.5 },
];
